import effects from 'app/effects/effects'
import {
  CLOSE_TOPIC_DIALOG,
  OPEN_TOPIC_DIALOG,
  SET_TOPIC_DIALOG_STATE,
  TOPIC_INVALID_FORM,
  TOPIC_SUBMIT_INIT,
  TOPIC_SUBMIT_SUCCESS,
  TOPIC_VALID_FORM,
  SET_TOPIC_DELETE_DIALOG_STATE,
  TOPIC_NAME_HASNT_ERROR,
  TOPIC_NAME_ERROR,
  OPEN_ADD_SUBSCRIBERS,
  CLOSE_ADD_SUBSCRIBERS,
  SET_SUBSCRIBERS_TOPICS,
  GET_TOPIC_DETAIL,
} from '../constants/topic-constants'

export const openTopicDialog = () => ({
  type: OPEN_TOPIC_DIALOG,
})

export const closeTopicDialog = () => ({
  type: CLOSE_TOPIC_DIALOG,
})

export const setTopicDialogState = (dialogState) => ({
  type: SET_TOPIC_DIALOG_STATE,
  payload: dialogState,
})

export const setDeleteTopicDialogState = (deleteDialogState) => ({
  type: SET_TOPIC_DELETE_DIALOG_STATE,
  payload: deleteDialogState,
})

export const topicFormValid = () => ({
  type: TOPIC_VALID_FORM,
})

export const topicFormInvalid = () => ({
  type: TOPIC_INVALID_FORM,
})

export const topicSubmitInit = () => ({
  type: TOPIC_SUBMIT_INIT,
})

export const topicSubmitSucces = () => ({
  type: TOPIC_SUBMIT_SUCCESS,
})

export const topicNameError = () => ({
  type: TOPIC_NAME_ERROR,
})

export const topicNameNotError = () => ({
  type: TOPIC_NAME_HASNT_ERROR,
})

export const openAddSubscriber = () => ({
  type: OPEN_ADD_SUBSCRIBERS,
})

export const closeAddSubscriber = () => ({
  type: CLOSE_ADD_SUBSCRIBERS,
})

export const setSubscribersTopics = (subscriber) => ({
  type: SET_SUBSCRIBERS_TOPICS,
  payload: subscriber,
})

export const setTopicDetail = (data) => ({
  type: GET_TOPIC_DETAIL,
  payload: data,
})

export const getTopicDetail = (topicId) => {
  return (dispatch) => {
    effects.apis
      .getTopicId({
        topicId,
      })
      .then((res) => {
        dispatch(setTopicDetail(res.data[0]))
      })
  }
}
